import { translateKey } from '../../translate';

interface ITextTranslate {
    translateKey: string;
}

export function Translate(props: ITextTranslate) {
    return <>{translateKey(props.translateKey)}</>;
}
